.ux-copy-to-clipboard {
  display: block;

  &__button {
    background-color: transparent;
    border: 0;
    display: block;
    outline: 0;
    padding: 0;
    text-align: initial;
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  &__copy-area {
    cursor: pointer;
    display: block;
    position: relative;
  }

  &__message {
    padding-right: 5px;
  }
}
